import React from 'react';
import { ArrowLeft, Home } from 'lucide-react';
import { withNavigation } from './Common/withNavigation';

class NotFoundPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-16">
        {/* Tooth illustration using SVG in logo colors */}
        <div className="mb-8">
          <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M60 20C42.5 20 35 30 30 45C25 60 30 85 35 95C40 105 50 105 60 95C70 105 80 105 85 95C90 85 95 60 90 45C85 30 77.5 20 60 20Z"
              fill="#e6f7f5"
              stroke="#0ea5a5"
              strokeWidth="4"
            />
            <path
              d="M45 55C45 62.5 47.5 70 53 75C55.5 77.5 65 77.5 67 75C72.5 70 75 62.5 75 55C75 47.5 70 40 60 40C50 40 45 47.5 45 55Z"
              fill="#a5d729"
            />
            <path
              d="M60 55L50 65M60 55L70 65M60 55V45"
              stroke="#0ea5a5"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </svg>
        </div>

        {/* Error message */}
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-2 text-center">Oops!</h1>
        <h2 className="text-2xl md:text-3xl font-semibold text-teal-500 mb-6 text-center">Page Not Found</h2>

        <div className="max-w-md text-center mb-8">
          <p className="text-gray-600 mb-6">
            The page you're looking for is still under development or doesn't exist. Let's get you back to a healthy smile!
          </p>

          {/* Illustration of broken link */}
          <div className="flex justify-center mb-8">
            <div className="h-1 bg-gray-300 w-16 rounded-full mt-4 mr-2"></div>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 20L5 20C2.5 20 2.5 15 5 15L15 15" stroke="#a5d729" strokeWidth="3" strokeLinecap="round" />
              <path d="M25 15L35 15C37.5 15 37.5 20 35 20L25 20" stroke="#0ea5a5" strokeWidth="3" strokeLinecap="round" />
            </svg>
            <div className="h-1 bg-gray-300 w-16 rounded-full mt-4 ml-2"></div>
          </div>
        </div>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => this.props.navigate(-1)}
            className="flex items-center justify-center gap-2 px-6 py-3 bg-white text-teal-500 font-medium border-2 border-teal-500 rounded-lg hover:bg-teal-50 transition-colors"
          >
            <ArrowLeft size={18} />
            Go Back
          </button>

          <button
            onClick={() => this.props.navigate('/')}
            className="flex items-center justify-center gap-2 px-6 py-3 bg-lime-500 text-white font-medium rounded-lg hover:bg-lime-600 shadow-sm transition-colors"
          >
            <Home size={18} />
            Back to Homepage
          </button>
        </div>

        {/* Support information */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm">
            Need help? <a href="/contact" className="text-teal-500 hover:underline">Contact our support team</a>
          </p>
        </div>
      </div>
    );
  }
}

export default withNavigation(NotFoundPage);